<template>
  <v-dialog width="800px" :value="value" @input="toggleModal" persistent scrollable>
    <v-card class="kbLight">
      <v-toolbar color="kbBlue" dark flat>
        <v-toolbar-title>{{$t('general.selectProfilePhoto')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal(false)">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" style="background: rgba(0, 0, 0, 0.2); min-height: 50vh" v-if="!imageUrl">
            <v-row class="fill-height flex-column" align="center" justify="center">
              <v-btn class="mb-1" fab color="kbBlue" dark @click="onPickFile">
                <v-icon>cloud_upload</v-icon>
              </v-btn>
              <span class="white--text">{{$t('general.selectPhoto')}}</span>
              <input type="file" style="display: none" ref="fileInput" accept="image/*" @change="onFilePicked">
            </v-row>
          </v-col>
          <v-col cols="12" v-show="imageUrl" style="min-height: 50vh;">
            <vue-croppie
              style="max-height: 44vh"
              ref="croppieRef"
              :enableResize="false"
              :enableOrientation="true"
              @result="result"
              :viewport="{ width: 200, height: 200, type: 'square'}">
            </vue-croppie>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn class="mr-2" outlined color="primary" @click="imageUrl = ''">{{$t('general.delete')}}</v-btn>
        <v-btn color="kbBlue" dark @click="crop" :loading="loading">{{$t('general.save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import imagesService from '@/services/imagesService'
export default {
  data () {
    return {
      cropped: null,
      imageUrl: '',
      loading: false
    }
  },
  methods: {
    dataURLtoFile (dataurl, filename) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const files = event.target.files
      const filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return window.alert('Please add a valid file')
      }
      // eslint-disable-next-line
        const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
        this.bind()
      })
      fileReader.readAsDataURL(files[0])
    },
    bind () {
      this.$refs.croppieRef.bind({
        url: this.imageUrl
      })
    },
    crop () {
      this.loading = true

      const options = {
        format: 'jpeg',
        circle: false
      }

      this.$refs.croppieRef.result(options, async (output) => {
        this.cropped = output
        const imageFile = this.dataURLtoFile(this.cropped, 'file.jpg')

        const data = {
          picture: imageFile
        }

        const response = await imagesService.uploadImageApp(this.$store.getters.token, data)

        this.$emit('cropped', response.image)

        this.loading = false

        this.toggleModal()
      })
    },
    result (output) {
      this.cropped = output
    },
    rotate (rotationAngle) {
      // Rotates the image
      this.$refs.croppieRef.rotate(rotationAngle)
    },
    toggleModal (value) {
      this.imageUrl = ''
      this.$emit('input', value)
    }
  },
  props: ['value']
}
</script>
